<template>
  <div class="home-wrap">
    <div
      class="swiper-container swiper11"
      v-if="bannerList && bannerList.length"
    >
      <div class="swiper-wrapper">
        <div
          class="swiper-slide"
          v-for="(item, index) in bannerList"
          :key="index"
        >
          <img
            :src="baseUrl + item.strPicPath"
            alt=""
            style="width: 100%; height: 100%; object-fit: cover"
            @click="goToLink(item)"
          />
        </div>
      </div>
      <div class="com-size">
        <div class="swiper-pageNum">
          <span>{{ switchNumber(activeIndex + 1) }}</span> /
          {{ switchNumber(bannerList.length) }}
        </div>
        <div class="swiper-pagination1 swiper-pagination"></div>
      </div>
    </div>
    <div class="com-size">
      <div class="news-wrap">
        <div class="news-tabs">
          <div class="tab-btns">
            <div
              :class="{ active: index === newsTabIndex }"
              v-for="(item, index) in newsTabs"
              :key="index"
              @click="tabClick(item, index)"
            >
              {{ item.strColNameBak }}
            </div>
            <section @click="toChildList(newsTabs[newsTabIndex])">
              更多+
            </section>
          </div>
          <div class="news-content">
            <div
              class="news-swiper swiper22"
              v-if="newsBannerList && newsBannerList.length"
            >
              <div class="swiper-wrapper">
                <div
                  class="swiper-slide"
                  v-for="(item, index) in newsBannerList"
                  :key="index"
                >
                  <img :src="baseUrl + item.strPicPath" alt="" />
                  <div class="news-desc">
                    <div class="news-title one-text" @click="toDetail(item)">
                      {{ item.strMasTitle }}
                    </div>
                    <div class="swiper-pagination swiper-pagination2"></div>
                  </div>
                </div>
              </div>
            </div>
            <div class="news-box">
              <div
                class="news-list"
                v-for="(item, index) in newsList"
                :key="index"
                @click="toDetail(item)"
              >
                <!-- <div class="news-time">
                  {{ formatTime(item.strPubDate, 'YYYY') }}
                  <div>{{ formatTime(item.strPubDate, 'MM-DD') }}</div>
                </div> -->
                <!-- <div class="news-title two-text">{{ item.strMasTitle }}</div> -->
                <div class="news-title one-text">{{ item.strMasTitle }}</div>
                <div class="news-time">
                  {{ formatTime(item.strPubDate, 'YYYY-MM-DD') }}
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="news-ads">
          <div
            v-for="(item, index) in newsAdList"
            :key="index"
            @click="goToLink(item)"
          >
            <img :src="item.imgUrl" alt="" />
          </div>
        </div>
      </div>
      <div
        class="promotion-swiper swiper33"
        v-if="promotionList && promotionList.length"
      >
        <div class="swiper-wrapper">
          <div
            class="swiper-slide"
            v-for="(item, index) in promotionList"
            :key="index"
          >
            <img
              :src="baseUrl + item.strPicPath"
              alt=""
              style="width: 100%; height: 100%; object-fit: cover"
            />
          </div>
        </div>
        <div class="swiper-button-prev"></div>
        <div class="swiper-button-next"></div>
      </div>
      <!-- 人才服务 -->
      <div class="talent-service service-wrap">
        <div class="left">
          <div>人才服务</div>
          <div class="more-btn" @click="() => $router.push('/talent')">
            查看更多
            <img src="@/assets/images/home/more.png" alt="" />
          </div>
        </div>
        <div class="right">
          <div
            class="right-item"
            v-for="(item, index) in talentList"
            :key="index"
            @click="toService(index, '/talent')"
          >
            <img class="icon" :src="item.icon" alt="" />
            <img class="h-icon" :src="item.hIcon" alt="" />
            <div>
              <div>{{ item.title }}</div>
              <div class="desc">{{ item.desc }}</div>
            </div>
          </div>
        </div>
      </div>
      <!-- 智库服务 -->
      <div class="library-service service-wrap">
        <div class="left">
          <div>智库服务</div>
          <div class="more-btn" @click="() => $router.push('/library')">
            查看更多
            <img src="@/assets/images/home/more1.png" alt="" />
          </div>
        </div>
        <div class="right">
          <div
            class="right-item"
            v-for="(item, index) in libraryList"
            :key="index"
            @click="toService(index, '/library')"
          >
            <img class="icon" :src="item.icon" alt="" />
            <img class="h-icon" :src="item.hIcon" alt="" />
            <div>
              <div>{{ item.title }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 关于我们 -->
    <div class="business-wrap">
      <div class="com-size">
        <div class="c-title">关于我们</div>
        <div class="e-title">About Us</div>
        <div style="display: flex; justify-content: space-between">
          <div class="business-list range2">
            <div>
              <div class="b-title">安徽省人力资源有限公司</div>
              <div class="b-desc">
                安徽省人力资源有限公司是安徽国控集团的全资子公司，于2023年12月成立，注册资本金5亿元，是安徽国资系统首家省级人力资源服务专业化公司。公司愿景是成为省内标杆、全国一流的综合性人力资源服务商，使命是聚焦产业、汇聚...
                <span
                  @click="
                    () =>
                      $router.push(
                        '/overview?id=6da15a9cc0764bf7a4c78c1894bdf2d6'
                      )
                  "
                  >> 了解更多</span
                >
              </div>
            </div>
            <img src="@/assets/images/home/about1.png" alt="" />
          </div>
          <div class="business-list range1">
            <div>
              <div class="b-title">安徽国资国企研究院</div>
              <div class="b-desc">
                安徽国资国企研究院有限公司是在安徽省国资委指导下，由安徽国控集团牵头联合安徽省交通控股集团、安徽省能源集团、安徽省投资集团及上海国有资本运营研究院共同出资设立的高端智库机构。成立于2023年5月24日，旨在加快打造...
                <span
                  @click="
                    () =>
                      $router.push(
                        '/overview?id=61eb9414a5b44173b2555d397a9abad8'
                      )
                  "
                  >> 了解更多</span
                >
              </div>
            </div>
            <img src="@/assets/images/home/about2.png" alt="" />
          </div>
        </div>
      </div>
    </div>
    <div class="btm-wrap">
      <!-- 通知公告 -->
      <div class="notice-wrap com-size">
        <div
          v-for="(item, index) in noticeTabs"
          :key="index"
          class="notice-box"
          :class="item.class ? item.class : ''"
        >
          <div class="notice-bg" @click="toChildList(item)">
            <img :src="item.icon" alt="" />
            {{ item.strColNameBak }}
          </div>
          <div
            class="notice-list"
            v-for="(notice, ind) in item.children"
            :key="ind"
            @click="toDetail(notice)"
          >
            <section></section>
            <div class="one-text">{{ notice.strMasTitle }}</div>
            <span class="time">{{
              moment(notice.strPubDate).format('YYYY-MM-DD')
            }}</span>
          </div>
        </div>
      </div>
      <div class="link-wrap com-size">
        <div class="link-title">
          <img src="@/assets/images/home/link.png" alt="" />
          友情链接
        </div>
        <a-tabs v-model="friendTabIndex" size="large">
          <a-tab-pane
            v-for="(item, index) in friendTabs"
            :key="index"
            :value="index"
            :tab="item.name"
          >
            <div class="link-content">
              <div
                class="link-list"
                v-for="(link, ind) in item.children"
                :key="ind"
                @click="goToLink(link)"
              >
                {{ link.strName }}
              </div>
            </div>
          </a-tab-pane>
        </a-tabs>
      </div>
    </div>
    <!-- 广告位 -->
    <div class="adv-position" v-if="showAd">
      <div class="close" @click="showAd = false">
        <a-icon type="close" />关闭
      </div>
      <div class="company">安徽省人力资源有限公司</div>
      <div class="pt">招聘报名平台</div>
      <section @click="toAdv">去登录</section>
    </div>
  </div>
</template>

<script>
import {
  getWebPosition,
  getTopBanner,
  getMidBanner,
  getNetLinks,
  getInfoList,
  getBannerList,
} from '@/utils/api'

import Swiper, { Autoplay, Pagination, Navigation } from 'swiper'
import 'swiper/swiper-bundle.css'
Swiper.use([Autoplay, Pagination, Navigation])
import moment from 'moment'
import { mapState } from 'vuex'

export default {
  name: 'home',
  data() {
    return {
      moment,
      bannerList: [],
      swipers: ['.swiper11', '.swiper22', '.swiper33'],
      activeIndex: 0,
      newsTabs: [],
      noticeTabs: [],
      newsTabIndex: 0, //新闻tabindex
      newsList: [],
      newsBannerList: [],
      newsAdList: [
        {
          imgUrl: require('@/assets/images/home/news-img1.png'),
          // path: '/work?id=c96a4b23b13345ac919977f509c3da05&tabId=0b583176087a4f2fa4b50dbab6f06e30',
        },
        {
          imgUrl: require('@/assets/images/home/news-img2.png'),
          path: '/notice?id=52e49f41b388426bafc1bfc32b88a866'
        },
        {
          imgUrl: require('@/assets/images/home/news-img3.png'),
          path: '/notice?id=05ceacb43ce3454083844eaeda31eac1',
        },
        // {
        //   imgUrl: require('@/assets/images/home/news-img4.jpg'),
        //   path: '/notice?id=05ceacb43ce3454083844eaeda31eac1',
        // },
      ],
      promotionList: [],
      talentList: [
        {
          icon: require('@/assets/images/home/talent-img1.png'),
          hIcon: require('@/assets/images/home/talent-h-img1.png'),
          title: '高端人才引进',
          desc: '招聘招引 | 考试测评',
        },
        {
          icon: require('@/assets/images/home/talent-img2.png'),
          hIcon: require('@/assets/images/home/talent-h-img2.png'),
          title: '人才创新创业',
          desc: '活动承办 | 成果转化',
        },
        {
          icon: require('@/assets/images/home/talent-img3.png'),
          hIcon: require('@/assets/images/home/talent-h-img3.png'),
          title: '人才数据开发',
          desc: '人才地图 | 发展报告',
        },
        {
          icon: require('@/assets/images/home/talent-img4.png'),
          hIcon: require('@/assets/images/home/talent-h-img4.png'),
          title: '人才综合服务',
          desc: '管理咨询 | 用工服务',
        },
        {
          icon: require('@/assets/images/home/talent-img5.png'),
          hIcon: require('@/assets/images/home/talent-h-img5.png'),
          title: '人才融合发展',
          desc: '校企合作 | 人才培养',
        },
      ],
      libraryList: [
        {
          icon: require('@/assets/images/home/service-img1.png'),
          hIcon: require('@/assets/images/home/service-h-img1.png'),
          title: '战略咨询',
        },
        {
          icon: require('@/assets/images/home/service-img2.png'),
          hIcon: require('@/assets/images/home/service-h-img2.png'),
          title: '产业研究',
        },
        {
          icon: require('@/assets/images/home/service-img3.png'),
          hIcon: require('@/assets/images/home/service-h-img3.png'),
          title: '国资培训',
        },
        {
          icon: require('@/assets/images/home/service-img4.png'),
          hIcon: require('@/assets/images/home/service-h-img4.png'),
          title: '资源赋能',
        },
        {
          icon: require('@/assets/images/home/service-img5.png'),
          hIcon: require('@/assets/images/home/service-h-img5.png'),
          title: '人才建设',
        },
        {
          icon: require('@/assets/images/home/service-img6.png'),
          hIcon: require('@/assets/images/home/service-h-img6.png'),
          title: '国资论坛',
        },
      ],
      friendTabs: [
        {
          name: '政府部门',
          children: [],
        },
        {
          name: '国控系统',
          children: [],
        },
        {
          name: '其他网站',
          children: [],
        },
      ],
      friendTabIndex: 0,
      baseUrl: window.$configUrl.apiUrl,
      swiperOptions1: undefined,
      swiperOptions2: undefined,
      swiperOptions3: undefined,
      // 广告位
      showAd: true,
      adPosition: { top: 100, left: 100 },
      adDirection: { x: 2, y: 2 },
      adTimer: null,
    }
  },
  computed: {
    ...mapState(['webNavList']),
  },
  async mounted() {
    // this.startAdFloating()
    this.getWebPositionFn()
    this.getNetLinksFn()
    await this.getTopBannerFn()
    await this.getMidBannerFn()
    // this.initSwiper()
  },
  methods: {
    async getWebPositionFn() {
      const { code, data } = await getWebPosition()
      // console.log(data, 'getWebNavigation')
      if (code == 200) {
        const noticeData = [
          {
            class: '',
            icon: require('@/assets/images/home/promotion.png'),
          },
          {
            class: 'trends-box',
            icon: require('@/assets/images/home/star.png'),
          },
          {
            class: 'policy-box',
            icon: require('@/assets/images/home/rczc.png'),
          },
        ]
        this.newsTabs = data.slice(0, 4)
        this.noticeTabs = data.slice(-3).map((item, index) => {
          this.getInfoListFn(item, 5)
          item.class = noticeData[index].class
          item.icon = noticeData[index].icon
          item.children = []
          return item
        })
        if (this.newsTabs && this.newsTabs.length) {
          this.getInfoListFn(this.newsTabs[0])
          this.getBannerListFn(this.newsTabs[0], 4)
        }
      }
    },
    // 头部大banner
    async getTopBannerFn() {
      const { code, data } = await getTopBanner()
      if (code == 200) {
        this.bannerList = data
        this.$nextTick(() => {
          this.swiperOptions1 = new Swiper('.swiper11', {
            autoplay: {
              delay: 50000,
              disableOnInteraction: false,
            },
            pagination: {
              el: '.swiper-pagination1',
              clickable: true,
            },
            on: {
              slideChange: (swiper) => {
                this.activeIndex = swiper.activeIndex
              },
            },
          })
        })
      }
    },
    // 中间banner
    async getMidBannerFn() {
      const { code, data } = await getMidBanner()
      if (code == 200) {
        this.promotionList = data
        this.$nextTick(() => {
          // 轮播图自动滚动
          this.swiperOptions3 = new Swiper('.swiper33', {
            // autoplay: {
            //   delay: 3000, // 设置为3秒自动切换
            //   disableOnInteraction: false,
            // },
            loop: true,
            navigation: {
              nextEl: '.swiper-button-next',
              prevEl: '.swiper-button-prev',
            },
          })
        })
      }
    },
    // 友情链接
    async getNetLinksFn() {
      const { code, data } = await getNetLinks()
      if (code == 200) {
        this.friendTabs.map((item) => {
          const list = data.filter((i) => i.strLinkName == item.name)
          item.children = list
          return item
        })
      }
    },
    // list
    async getInfoListFn(item, rows = 4) {
      const params = {
        strColId: item.strColId,
        rows,
        currentPage: 1,
      }
      const {
        code,
        data: { dataList },
      } = await getInfoList(params)
      if (code == 200) {
        // 通知公告
        if (rows == 5) {
          this.noticeTabs.map((it) => {
            if (it.strColName == item.strColName) {
              it.children = dataList
            }
            return it
          })
          console.log(this.noticeTabs, 'this.newsList')
        } else {
          this.newsList = [...dataList]
        }
      }
    },
    // 新闻banner
    async getBannerListFn(item, rows = 4) {
      const params = {
        strColId: item.strColId,
        rows,
        currentPage: 1,
      }
      const { code, data } = await getBannerList(params)
      if (code == 200) {
        this.newsBannerList = data
        if (this.swiperOptions2) {
          this.swiperOptions2.destroy(true, true)
        }
        this.$nextTick(() => {
          this.swiperOptions2 = new Swiper('.swiper22', {
            autoplay: {
              delay: 50000,
              disableOnInteraction: false,
            },
            // loop: true,
            pagination: {
              el: '.swiper-pagination2',
              clickable: true,
            },
          })
        })
      }
    },
    initSwiper() {},
    destroySwiper(swiper) {
      if (this[swiper]) {
        this[swiper].destroy(true, true) // 完全销毁 Swiper 并移除事件监听器
        this[swiper] = undefined
      }
    },
    tabClick(item, index) {
      if (this.newsTabIndex == index) return
      this.newsTabIndex = index
      this.getInfoListFn(item)
      this.getBannerListFn(item, 4)
    },
    switchNumber(num) {
      return num < 10 ? `0${num}` : num
    },
    formatTime(time, type) {
      return moment(time).format(type)
    },
    toChildList(item) {
      const list = this.webNavList.find((it) => {
        if (item.strParentId == it.strColumnId) return true
        if (it.children && it.children.length) {
          const list2 = it.children.find(
            (it2) => item.strParentId == it2.strColumnId
          )
          if (list2 && list2.strColumnId) return list2
        }
      })
      console.log(item, 'toChildList', this.webNavList, list)
      if (list) {
        this.$router.push({
          path: '/' + list.strRoute,
          query: {
            id: item.strParentId,
            tabId: item.strColId,
          },
        })
      } else {
        this.$store.commit('setBreadcrumbs', item)
        this.$router.push({
          path: '/childList',
          query: {
            id: item.strColId,
          },
        })
      }
    },
    toDetail(item) {
      if (item.strEditType == 'url') {
        return window.open(item.strHtmlUrl, '_blank')
      }
      window.open(
        this.$router.resolve({
          path: '/detail',
          query: {
            id: item.strId,
            strColId: this.strColId,
          },
        }).href,
        '_blank'
      )
    },
    // 专题页跳转
    goToLink(item) {
      if (item.path) {
        return this.$router.push(item.path)
      }
      item.strURL && window.open(item.strURL)
    },
    // 去人才服务和智库服务
    toService(index, path) {
      this.$router.push({
        path: path,
        query: {
          tabId: index,
        },
      })
    },
    // ==========广告位
    startAdFloating() {
      // 启动广告飘浮
      if (this.adTimer) {
        clearInterval(this.adTimer)
        this.adTimer = null
      }
      const adWidth = 220
      const adHeight = 140
      this.adTimer = setInterval(() => {
        if (!this.showAd) return
        let { top, left } = this.adPosition
        let { x, y } = this.adDirection
        const winWidth = window.innerWidth
        const winHeight = window.innerHeight

        left += x
        top += y

        if (left <= 0) {
          left = 0
          x = -x
        } else if (left + adWidth >= winWidth) {
          left = winWidth - adWidth
          x = -x
        }
        if (top <= 0) {
          top = 0
          y = -y
        } else if (top + adHeight >= winHeight) {
          top = winHeight - adHeight
          y = -y
        }
        this.adPosition = { top, left }
        this.adDirection = { x, y }
      }, 50)
    },
    pauseAdFloating() {
      // 鼠标移入广告，暂停飘浮
      if (this.adTimer) {
        clearInterval(this.adTimer)
        this.adTimer = null
      }
    },
    toAdv() {
      window.open('http://ahgzcz.pzhl.net', '_blank')
    },
  },
  beforeDestroy() {
    // clearInterval(this.adTimer)
  },
  destroyed() {
    if (this.swiperOptions1) this.swiperOptions1.destroy(true, true)
    if (this.swiperOptions2) this.swiperOptions2.destroy(true, true)
    if (this.swiperOptions3) this.swiperOptions3.destroy(true, true)
  },
}
</script>

<style scoped lang="less">
.hello {
  width: 100%;
  height: 100%;
}

.video-box {
  position: relative;
  width: 100%;
  height: auto;
  .vjs-default-skin {
    width: 100%;
    height: auto;
  }

  .video-js .vjs-tech {
    position: relative;
  }
  .logo {
    position: absolute;
    left: 40px;
    top: 50px;
  }
}

.register {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 60px 0;
  gap: 100px;

  .item {
    position: relative;
    width: 400px;
    height: 180px;
    background-color: #ccc;
    font-size: 16px;
    border-radius: 8px;
    .theme {
      position: absolute;
      bottom: 30px;
      left: 20px;
      color: #fff;
      font-size: 14px;
      line-height: 20px;
      max-width: 230px;
    }
    .zhTheme {
      bottom: 40px;
      font-size: 16px;
    }
    .countdown {
      position: absolute;
      top: 50%;
      right: -30px;
      transform: translateY(-50%);
      width: 186px;
      height: 132px;
      background-color: #fff;
      box-shadow: 0 1px 20px 0 rgba(88, 6, 1, 0.2);
      border-radius: 8px;
      padding: 20px 20px;
      .dateline {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-bottom: 10px;
      }
      .day {
        display: flex;
        justify-content: center;
        align-items: flex-end;
        font-size: 50px;
        font-weight: 700;
        color: #e73429;
        span {
          font-size: 18px;
          margin-left: 8px;
          font-weight: 600;
        }
      }
    }
  }

  .timeout {
    // background: url("@/assets/img/setTimtOut.png") no-repeat;//
    // background-size: cover;
  }
  .login {
    background: url('@/assets/img/register.png') no-repeat;
    background-size: cover;
    padding: 80px;
    font-size: 28px;
    color: #fff;
  }
}
.activity {
  position: relative;
  padding: 0px 40px 60px;
  max-width: 1260px;
  margin: 0 auto;
}
.activeTitle {
  text-align: center;
  padding: 20px;
  font-size: 38px;
  position: relative;
  margin-bottom: 30px;
  &::before {
    background: -webkit-gradient(
      linear,
      left top,
      right top,
      from(#00b3e4),
      color-stop(50%, #2b439b),
      to(#d9026b)
    );
    background: linear-gradient(90deg, #00b3e4, #2b439b 50%, #d9026b);
    content: '';
    width: 38px;
    height: 6px;
    border-radius: 3px;
    position: absolute;
    left: 50%;
    bottom: 0px;
    margin-left: -18px;
  }
}

.swiper-slide {
  position: relative;
  width: 100%;
  // aspect-ratio: 380/460;
  border-radius: 20px;
  // cursor: pointer;
  // max-height: 385px;
  height: 100%;
}

.title {
  position: absolute;
  top: 40px;
  left: 24px;
  max-width: 294px;
  font-weight: 500;
  font-size: 25px;
  margin-bottom: 15px;
  color: #fff;
  line-height: 36px;
  &::before {
    background: #f5f5f5;
    content: '';
    width: 48px;
    height: 6px;
    border-radius: 3px;
    position: absolute;
    left: 0;
    bottom: -18px;
  }
}
@media screen and (max-width: 760px) {
  .register {
    flex-direction: column;
    gap: 40px;
    padding: 60px;

    .item {
      width: 80%;
    }
  }

  .title {
    font-size: 18px;
  }
}

// banner轮播图
::v-deep.swiper-container {
  margin-bottom: 40px;
  .com-size {
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
    height: 16px;
    z-index: 999;
    bottom: 15px;
  }
  .swiper-pagination1 {
    right: 0;
    .swiper-pagination-bullet {
      width: 12px;
      height: 12px;
      background: rgba(255, 255, 255, 1);
      border-radius: 50%;
      margin-left: 5px;
    }
    .swiper-pagination-bullet-active {
      width: 30px;
      height: 12px;
      background: #ffffff;
      border-radius: 6px;
    }
  }
  .swiper-pageNum {
    position: absolute;
    left: 0;
    color: rgba(255, 255, 255, 0.5);
    font-size: 18px;
    bottom: 0;
    span {
      color: #fff;
      font-size: 30px;
    }
  }
}
.news-wrap {
  display: flex;
  width: 100%;
  margin-bottom: 16px;
  .news-tabs {
    flex-grow: 1;
    width: calc(100% - 390px);
    .tab-btns {
      display: flex;
      // justify-content: space-between;
      margin-bottom: 22px;
      > div {
        width: 108px;
        height: 46px;
        line-height: 46px;
        background: #f2f2f2;
        border-radius: 4px;
        text-align: center;
        color: #333;
        font-size: 16px;
        font-weight: bold;
        margin-right: 24px;
        cursor: pointer;
        &.active {
          background: #d5030d;
          color: #fff;
        }
      }
      section {
        margin-left: auto;
        font-size: 14px;
        color: #d5030d;
        line-height: 30px;
        margin-top: auto;
        cursor: pointer;
      }
    }
  }
  .news-box {
    flex-grow: 1;
    margin-left: 20px;
    margin-top: -15px;
    width: calc(100% - 550px);
    .news-list {
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 27px 0;
      border-bottom: 1px dashed #ddd;
      .news-time {
        font-size: 16px;
        color: #777;
        flex-shrink: 0;
        margin-left: 10px;
      }
      .news-title {
        font-weight: 400;
        font-size: 18px;
        color: #333333;
        line-height: 24px;
        cursor: pointer;
      }
    }
  }
  .news-ads {
    flex-shrink: 0;
    width: 240px;
    margin-left: 30px;
    div {
      margin-top: 20px;
      &:first-of-type {
        margin-top: 8px;
      }
      img {
        width: auto;
        height: auto;
        display: block;
        cursor: pointer;
      }
    }
  }
}
// 新闻轮播图
::v-deep.news-content {
  display: flex;
  .news-swiper {
    width: 490px;
    overflow-x: hidden;
    padding: 1px;
    flex-shrink: 0;
  }
  .swiper-slide {
    background: #ffffff;
    box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.1);
    border-radius: 4px;
    max-height: 410px;
    img {
      height: 250px;
      width: 100%;
      object-fit: cover;
      display: block;
    }
    .news-desc {
      width: 100%;
      font-weight: 400;
      font-size: 14px;
      color: #999999;
      padding: 18px 16px;
      position: relative;
      display: flex;
      align-items: center;
      justify-content: space-between;
      .news-title {
        font-weight: bold;
        font-size: 18px;
        color: #333333;
        cursor: pointer;
        flex-grow: 1;
      }
    }
  }
  .swiper-pagination {
    position: relative;
    flex-shrink: 0;
    margin-left: 10px;
    .swiper-pagination-bullet {
      width: 10px;
      height: 10px;
      background: rgba(0, 0, 0, 0.5);
      border-radius: 50%;
      margin-left: 5px;
    }
    .swiper-pagination-bullet-active {
      width: 30px;
      height: 10px;
      background: #d5030d;
      border-radius: 6px;
    }
  }
}

// 中间的轮播图
::v-deep.promotion-swiper {
  overflow-x: hidden;
  position: relative;
  margin-bottom: 30px;
  .swiper-slide {
    img {
      height: 100%;
      width: 100%;
      object-fit: cover;
      display: block;
    }
  }
  .swiper-button-prev {
    width: 48px;
    height: 48px;
    left: 50px;
    &::after {
      background: url('@/assets/images/home/swiper-prev.png') no-repeat;
      background-size: cover;
      content: '';
      width: 100%;
      height: 100%;
    }
  }
  .swiper-button-next {
    width: 48px;
    height: 48px;
    right: 50px;
    &::after {
      background: url('@/assets/images/home/swiper-next.png') no-repeat;
      background-size: 100% 100%;
      content: '';
      width: 100%;
      height: 100%;
    }
  }
}
//人才服务 智库服务
.service-wrap {
  display: flex;
  width: 100%;
  height: 160px;
  margin-bottom: 30px;
  > .left {
    width: 150px;
    flex-shrink: 0;
    padding-top: 32px;
    padding-left: 20px;
    font-weight: bold;
    font-size: 26px;
    color: #ffffff;
    .more-btn {
      margin-top: 18px;
      display: flex;
      align-items: center;
      justify-content: center;
      width: 88px;
      height: 21px;
      line-height: 21px;
      background: rgba(11, 56, 65, 0.22);
      border-radius: 11px;
      font-weight: 400;
      font-size: 12px;
      cursor: pointer;
      margin-left: 5px;
      img {
        margin-left: 8px;
      }
    }
  }
  > .right {
    flex-grow: 1;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0 20px;
  }
  .right-item {
    width: 225px;
    height: 90px;
    background: #ffffff;
    border: 1px solid #febcbf;
    display: flex;
    align-items: center;
    padding: 15px 0 15px 14px;
    cursor: pointer;
    font-size: 18px;
    color: #333333;
    img {
      margin-right: 12px;
    }
    .h-icon {
      display: none;
    }
    .desc {
      margin-top: 10px;
      font-size: 14px;
      color: #999999;
    }
    &:hover {
      background: #d5030d;
      border-color: #d5030d;
      color: #ffffff;
      .h-icon {
        display: block;
      }
      .icon {
        display: none;
      }
      .desc {
        color: #fff;
      }
    }
  }
  &.talent-service {
    background: url('@/assets/images/home/talent-bg.png') no-repeat;
    background-size: 100% 100%;
  }
  &.library-service {
    background: url('@/assets/images/home/service-bg.png') no-repeat;
    background-size: 100% 100%;
    .right-item {
      width: 180px;
      border-color: #aec2e8;
      &:hover {
        background: #3a67fa;
        border-color: #3a67fa;
      }
    }
  }
}
// 经营范围
.business-wrap {
  background: url('@/assets/images/home/business-bg.jpg') no-repeat;
  width: 100%;
  height: 550px;
  background-size: 100% 100%;
  .com-size {
    padding: 50px 25px;
  }
  .c-title {
    font-weight: bold;
    font-size: 28px;
    color: #d5030d;
    margin-bottom: 10px;
    span {
      color: #333;
    }
  }
  .e-title {
    font-size: 12px;
    color: #d5030d;
    margin-bottom: 40px;
  }
  .business-list {
    background: url('@/assets/images/home/business-range1.png') no-repeat;
    width: 656px;
    height: 329px;
    background-size: 100% 100%;
    padding: 10px 10px 10px 55px;
    display: flex;
    align-items: center;
    &.range2 {
      background: url('@/assets/images/home/business-range2.png') no-repeat;
      background-size: 100% 100%;
      .b-title {
        //color: #0165ff;
      }
    }
    .b-title {
      font-weight: bold;
      font-size: 24px;
      color: #de261a;
      margin-bottom: 30px;
    }
    .b-desc {
      font-size: 16px;
      color: #333333;
      line-height: 30px;
      position: relative;
      span {
        position: absolute;
        left: 50px;
        bottom: 0;
        font-size: 12px;
        color: #d5030d;
        cursor: pointer;
      }
    }
    > img {
      width: 299px;
      height: 257px;
      flex-shrink: 0;
      margin-left: 10px;
    }
  }
}
.btm-wrap {
  background: linear-gradient(0deg, #fef8f1 0%, #f7f7f7 46%);
  padding: 40px 0;
}
// 通知公告
.notice-wrap {
  display: flex;
  justify-content: space-between;
  .notice-box {
    width: 440px;
    background: #ffffff;
    padding: 20px 20px 0;
  }
  .notice-bg {
    background: url('@/assets/images/home/notice-bg.png') no-repeat;
    width: 100%;
    height: 75px;
    background-size: 100% 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    font-weight: bold;
    font-size: 24px;
    color: #ffffff;
    cursor: pointer;
    img {
      margin-right: 10px;
    }
  }
  .notice-list {
    padding: 19px 0;
    display: flex;
    align-items: center;
    font-size: 16px;
    color: #333333;
    line-height: 23px;
    border-bottom: 1px solid #f2f2f2;
    cursor: pointer;
    &:last-of-type {
      border-bottom: none;
    }
    section {
      width: 8px;
      height: 8px;
      background: #025be5;
      border-radius: 50%;
      margin-right: 5px;
      flex-shrink: 0;
    }
    > div {
      margin-right: 10px;
    }
    .time {
      color: #999;
      margin-left: auto;
      flex-shrink: 0;
    }
  }
  .trends-box {
    .notice-bg {
      background: url('@/assets/images/home/trends-bg.png') no-repeat;
      background-size: 100% 100%;
    }
    .notice-list {
      section {
        background: #d5030d;
      }
    }
  }
  .policy-box {
    .notice-bg {
      background: url('@/assets/images/home/policy-bg.png') no-repeat;
      background-size: 100% 100%;
    }
    .notice-list {
      section {
        background: #dc7700;
      }
    }
  }
}
// 友情链接
.link-wrap {
  margin-top: 30px;
  background: #ffffff;
  padding: 0 30px;
  .link-title {
    background: url('@/assets/images/home/link-bg.png') no-repeat;
    width: 160px;
    height: 40px;
    background-size: 100% 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 18px;
    color: #ffffff;
    margin: 0 auto 40px;
    img {
      margin-right: 5px;
    }
  }
  .link-list {
    font-size: 16px;
    color: #333333;
    line-height: 23px;
    margin-bottom: 5px;
  }
}
::v-deep .ant-tabs-nav-scroll {
  text-align: center;
  .ant-tabs-tab {
    &:active,
    &:hover {
      color: #e91a2e;
    }
    &.ant-tabs-tab-active {
      color: #e91a2e;
    }
  }
  .ant-tabs-ink-bar {
    background: #e91a2e;
  }
}
.link-content {
  display: flex;
  flex-wrap: wrap;
  padding: 30px;
  justify-content: center;
  .link-list {
    padding: 0 24px;
    border-right: 1px solid #ccc;
    font-size: 15px;
    color: #000;
    cursor: pointer;
    &:last-of-type {
      border-right: none;
    }
  }
}
// .floating-ad {
//   position: fixed;
//   z-index: 9999;
//   transition: top 0.1s linear, left 0.1s linear; // 平滑过渡
//   pointer-events: auto;
// }
.adv-position {
  position: fixed;
  top: 600px;
  z-index: 9999;
  width: 220px;
  background: #ffffff;
  box-shadow: 0px 2px 15px 0px rgba(0, 0, 0, 0.08);
  border-radius: 4px;
  font-size: 12px;
  left: 20px;
  text-align: center;
  padding: 22px 10px;
  z-index: 999;
  .close {
    position: absolute;
    right: 10px;
    z-index: 999;
    color: #333333;
    cursor: pointer;
    top: -20px;
    left: 0;
    text-align: left;
  }
  .company {
    font-size: 15px;
    color: #e50202;
  }
  .company {
    font-size: 15px;
    color: #e50202;
    margin-bottom: 12px;
  }
  .pt {
    font-weight: bold;
    font-size: 16px;
    color: #000000;
    margin-bottom: 20px;
  }
  section {
    width: 120px;
    height: 30px;
    line-height: 30px;
    background: #db0303;
    border-radius: 15px;
    font-weight: bold;
    font-size: 14px;
    color: #ffffff;
    text-align: center;
    margin: auto;
    cursor: pointer;
  }
}
</style>
